import React from 'react';
import { includes, some } from 'lodash';
import PropTypes from 'prop-types';
import UserSession from '../../auth/UserSession';
import { Loading, If } from '../../common';
import { publicRuntimeConfig } from 'config';
const { usersWhiteList = [] } = publicRuntimeConfig || {};

const HasPermissions = ({ children, otherwise, to, isDisabled }) => (
    <UserSession typeCache>
        {({ resources, loading, session, email }) => (
            <>
                <If condition={loading} then={<Loading loading />} />
                <If
                    condition={isDisabled || (!loading && (some(to, (resource) => includes(resources, resource)) || includes(usersWhiteList, email)))}
                    then={children}
                    else={otherwise}
                />
            </>
        )}
    </UserSession>

);

HasPermissions.propTypes = {
    children: PropTypes.any,
    otherwise: PropTypes.any,
    to: PropTypes.array,
    isDisabled: PropTypes.bool
};

HasPermissions.defaultProps = {
    isDisabled: false,
    otherwise: () => (null),
    resources: []
};

export default HasPermissions;
